// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COVER_PHOTO_CHANGE = "Zme\u0148 fotku";
export const COVER_PHOTO_REMOVE = "Odstr\u00e1\u0148 fotku";
export const GROUP_NAME = "N\u00e1zov skupiny";
